import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';

import { useSnackBar } from '../../hooks/snackBar';

import { useFormik } from 'formik';

import { formPrimeiroAcessoValidator } from './FormLoginValidator';

import { primeiroAcessoSeller, resetarSenha } from '../../services/http/sellerService';

import FormLogin from './FormLogin';
import Modal from '../../components/Modal';
import FormCadUsuarioPrimeiroAcesso from './FormCadUsuarioPrimeiroAcesso';

import services from '../../services';

import FormControl from '@material-ui/core/FormControl';

import TextField from '@material-ui/core/TextField';

import { efetuarLogin } from '../../services/http/loginService';

import { mapearData, formLoginInitialState } from './FormLoginValidator';

import './styles.scss';
import globals from '../../globals';

const REACT_APP_TERMO_USO = globals.REACT_APP_TERMO_USO;

const Login = props => {

    const history = useHistory();
    const location = useLocation();

    const { addSnackBar } = useSnackBar();


    const [formLogin, setFormLogin] = useState({ ...formLoginInitialState });
    const [openModalEsqueci, setOpenModalEsqueci] = useState(false);
    const [openModalPrimeiroAcesso, setOpenModalPrimeiroAcesso] = useState(false);
    const [openModalCadUsuario, setOpenModalCadUsuario] = useState(false);
    const [emailObj, setEmailEsqueciSenha] = useState({ email: '' });
    const [idEmpresa, setIdEmpresa] = useState('');
    const [isFormInvalid, setIsFormInvalid] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);

    const formik = useFormik({
        initialValues: { cnpj: '' },
        validationSchema: formPrimeiroAcessoValidator,
        onSubmit: (values) => {
            primeiroAcesso(values);
        }
    })

    const handleOpenModalEsqueci = () => { setOpenModalEsqueci(true) };
    const handleCloseModalEsqueci = () => { setOpenModalEsqueci(false) };

    const handleOpenModalAcesso = () => { setOpenModalPrimeiroAcesso(true) };
    const handleCloseModalAcesso = () => { setOpenModalPrimeiroAcesso(false) };

    const handleOpenModalCadUsuario = () => { setOpenModalCadUsuario(true) };
    const handleCloseModalCadUsuario = () => { setOpenModalCadUsuario(false) };

    const primeiroAcesso = (values) => {
        let data = {
            cnpj: services.mask.unMask(values.cnpj)
        }

        trackPromise(
            primeiroAcessoSeller(data)
                .then(res => {

                    if (res.fail) {
                        addSnackBar({ message: 'Erro ao tentar efetuar primeiro acesso.', info: 'error', open: true })
                    }

                    if (res.data) {
                        setIdEmpresa(res.data.idSeller);

                        handleCloseModalAcesso();
                        handleOpenModalCadUsuario();
                    }
                })
        ).catch(error => {
            console.log(error);
            addSnackBar({ message: 'Erro ao tentar efetuar primeiro acesso.', info: 'error', open: true })
        })
    }

    const validarForm = () => {
        var isInvalidForm = false;
        if (!emailObj.email) isInvalidForm = true;

        setIsFormInvalid(isInvalidForm);

        return isInvalidForm;
    }

    const resetarSenhaUsuario = () => {
        if (!validarForm()) {
            trackPromise(
                resetarSenha(emailObj)
                    .then(res => {
                        if (res.fail) {
                            res.errors.forEach(item => {
                                addSnackBar({ message: item.menssagem, info: 'warning', open: true })
                            })
                        }
                        else {
                            addSnackBar({ message: 'Uma nova senha foi enviada para seu e-mail', info: 'success', open: true })
                            setOpenModalEsqueci(false);
                        }
                    })
            ).catch(error => {
                console.log(error);
                addSnackBar({ message: 'Erro ao tentar resetar senha.', info: 'error', open: true })
            })
        }
    }

    const logar = (values) => {

        let data = mapearData(values);

        trackPromise(
            efetuarLogin(data)
                .then(res => {
                    if (res.fail) {
                        res.errors.forEach(element => {
                            addSnackBar({ message: element.menssagem, info: 'warning', open: true });
                        });
                    }

                    if (res.data) {
                        services.storage.set('authSistema', res.data);
                        services.storage.set('isAuthenticated', true);
                        history.push(`/home`);
                    }
                })
        ).catch(error => {
            console.log('Erro ao carregar lista de cadastro');
        })
    }

    const handleChangeLogin = (value, campo) => {
        setFormLogin(prevstate => ({ ...prevstate, [campo]: value }))
    }

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    return (
        <div className="container-page loginPage">
            {
                (width>768)?
                <div className='borda-lateral '  ></div>:null
            }
             
            <div className='container'>
                <br/>
                <div className="headerLogin" style={{ height: '30px' }}></div>

                <div className='row'>
                    <div className='col-md-12 boxCadastroBg'>
                        <div className='boxCadastro'>
                            <FormLogin
                                formPage={formLogin}
                                action={logar}
                                modalSenha={handleOpenModalEsqueci}
                                modalAcesso={handleOpenModalAcesso}
                            />
                        </div>
                    </div>
                </div>
                <Modal
                    open={openModalEsqueci} close={handleCloseModalEsqueci}
                    type="modal-recuperar-senha"
                    size="lg"
                    /*classTop="modal-title"*/
                    className="minModalSize"
                    >
                    <div class={"row " + (width>768?"":"mlMin70") + " w230"} >
                        {
                            (width>768)?
                            <div className="modal-content col-sm-none col-md-12 col-lg-12">
                                <center>
                                    <p >Esqueci minha senha</p>
                                </center>
                            </div>:
                            <div className="modal-content col-sm-12 col-md-12 col-lg-12  ">
                                <center>
                                    Esqueci minha senha
                                </center>
                            </div>
                        }
                        
                    </div>
                    <div class={"row " + (width<768?"mlMin70":"") + " w240"}  >
                        <div className="col-md-12 col-sm-12 col-lg-12"  >
                          <FormControl >
                            <TextField
                                label="E-mail"
                                type="text"
                                size="small"
                                placeholder="Informe seu e-mail cadastrado"
                                onChange={event => setEmailEsqueciSenha((prevent) => ({ ...prevent, email: event.target.value }))}
                                value={emailObj.email}
                                className="TextField"
                                helperText={isFormInvalid && !emailObj?.email && 'Campo obrigatório'}
                                error={isFormInvalid && !emailObj?.email ? true : false}
                                id="outlined-basic"
                                variant="outlined"
                            />
                            </FormControl>
                        </div>
                        
                    </div>
                    <div class={"row w250 " + (width<768?"mlMin75":"") } >
                        <div className="col-md-12 col-sm-12 col-lg-12 w100p ">
                            <button onClick={() => resetarSenhaUsuario()} className=" mt20 buton-green w100p h50">
                                OK
                            </button>
                        </div>
                    </div>

                    {/*
                    className="row"
                            <div className="modal-content col-sm-12 col-md-12 col-lg-12">
                                                    <p className='col-sm-12 col-md-12 col-lg-12'>Esqueci minha senha</p>
                                                    <div className="col-md-12 col-sm-12 col-lg-12">
                                                        <FormControl >
                                                            <TextField
                                                                label="E-mail"
                                                                type="text"
                                                                size="small"
                                                                placeholder="Informe seu e-mail cadastrado"
                                                                onChange={event => setEmailEsqueciSenha((prevent) => ({ ...prevent, email: event.target.value }))}
                                                                value={emailObj.email}
                                                                className="TextField"
                                                                helperText={isFormInvalid && !emailObj?.email && 'Campo obrigatório'}
                                                                error={isFormInvalid && !emailObj?.email ? true : false}
                                                                id="outlined-basic"
                                                                variant="outlined"
                                                            />
                                                        </FormControl></div>
                                                    <div className="col-md-12 col-sm-12 col-lg-12">
                                                        <button onClick={() => resetarSenhaUsuario()} className="col-sm-12 col-md-12 col-lg-12 mt20 buton-green">
                                                            OK
                                                        </button>
                                                    </div>


                                                </div>
                    */}
                    
                </Modal>



                <Modal
                    open={openModalPrimeiroAcesso} close={handleCloseModalAcesso}
                    type="modal-recuperar-senha"
                    size="lg"
                    classTop="modal-title"
                      >
                        <form onSubmit={formik.handleSubmit} >
                            <div class={"row " + (width>768?"":"mlMin70") + " w230"} >
                                {
                                    (width>768)?
                                    <div className="modal-content col-sm-none col-md-12 col-lg-12">
                                        <center>
                                            <p >Primeiro Acesso</p>
                                        </center>
                                    </div>:
                                    <div className="modal-content col-sm-12 col-md-12 col-lg-12  ">
                                        <center>
                                        Primeiro Acesso
                                        </center>
                                    </div>
                                }
                            </div>
                            <div class={"row " + (width<768?"mlMin70":"") + " w240"}  >
                                <div className="col-md-12 col-sm-12 col-lg-12">
                                    <FormControl  >
                                        <TextField
                                            label="CNPJ"
                                            type="text"
                                            size="small"
                                            id="cnpj"
                                            variant="outlined"
                                            placeholder="Informe o CNPJ cadastrado"
                                            value={services.mask.cpfCnpj(formik.values.cnpj)}
                                            onChange={formik.handleChange}
                                            error={formik.touched.cnpj && Boolean(formik.errors.cnpj)}
                                            helperText={formik.touched.cnpj && formik.errors.cnpj}
                                        />
                                    </FormControl>
                                </div>
                            </div>
                            <div class={"row w250 " + (width<768?"mlMin75":"") } >
                                <div className="col-md-12 col-sm-12 col-lg-12">
                                    <button
                                        className="col-sm-12 col-md-12 col-lg-12 mt20 buton-green w100p h50"
                                        type='submit'
                                    >
                                        OK
                                    </button>
                                </div>
                            </div>
                        </form>
                    {/*
                    className="row"
                    <div className="modal-content col-sm-12 col-md-12 col-lg-12">
                        <p className='col-sm-12 col-md-12 col-lg-12'>Primeiro Acesso</p>
                        <form onSubmit={formik.handleSubmit} >
                            <div className="col-md-12 col-sm-12 col-lg-12">
                                <FormControl  >
                                    <TextField
                                        label="CNPJ"
                                        type="text"
                                        size="small"
                                        id="cnpj"
                                        variant="outlined"
                                        placeholder="Informe o CNPJ cadastrado"
                                        value={services.mask.cpfCnpj(formik.values.cnpj)}
                                        onChange={formik.handleChange}
                                        error={formik.touched.cnpj && Boolean(formik.errors.cnpj)}
                                        helperText={formik.touched.cnpj && formik.errors.cnpj}
                                    />
                                </FormControl>
                            </div>
                            <div className="col-md-12 col-sm-12 col-lg-12">
                                <button
                                    className="col-sm-12 col-md-12 col-lg-12 mt20 buton-green"
                                    type='submit'
                                >
                                    OK
                                </button>
                            </div>
                        </form>
                    </div>
                    */}
                </Modal>

                <Modal
                    open={openModalCadUsuario} close={handleCloseModalCadUsuario}
                    type="modal-cadastrar-usuario"
                    size="lg"
                    classTop="modal-title"
                    /* classContent="modal-content"
                    className='container' */>
                    <div className="content">
                        {
                            (width>768)?
                            <p style={{ textAlign: 'center' }}>Primeiro Acesso</p>:
                            <div class="w120 textAlignCenter" >Primeiro Acesso</div>
                        }
                        
                        <FormCadUsuarioPrimeiroAcesso
                            idEmpresa={idEmpresa}
                            closeModal={handleCloseModalCadUsuario}
                        />
                    </div>
                </Modal>
            </div>
        </div>
    )
}

export default Login;